import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { CommentType } from 'APIs/BackstageCommentApi';
import OtrCommentInput from 'components/atoms/Inputs/OtrCommentInput';
import BackstageComment from 'interfaces/BackstageComment.interface';
import { OtrData } from 'interfaces/OtrData.interface';
import moment from 'moment';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';

const ExpandMore = styled((props: any) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(0deg)',
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
}));

const TitleSectionContent = styled(CardContent)(({ theme }) => ({
  padding: 'unset',
  display: 'flex',
  justifyContent: 'space-between',
  '&:last-child': {
    padding: 'unset',
  },
}));

const InsideBottomContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  width: '100%',
  gap: '10px',
  marginTop: '15px',
}));

const UserSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'start',
  gap: '12px',
}));

const DetailSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'start',
  justifyContent: 'start',
  gap: '7px',
}));

const NameSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'start',
  gap: '20px',
}));

const NameText = styled(Typography)(({ theme }) => ({
  fontSize: '14px',
  color: '#ffffff',
  fontWeight: '500',
  cursor: 'pointer',
}));

const CommitText = styled(NameText)(({ theme }) => ({
  fontWeight: 'bold',
}));

const SmallText = styled(NameText)(({ theme }) => ({
  fontSize: '12px',
  color: '#c1c1c1',
  fontWeight: 'initial',
}));

interface CardCommentListsWithDataProps {
  data: BackstageComment;
  addComment?: (comment: BackstageComment, id: string) => void;
  otr?: OtrData;
  type: CommentType;
}

const CardCommentListsWithData: React.FC<CardCommentListsWithDataProps> = ({
  data,
  addComment,
  otr,
  type,
}) => {
  const navigate = useNavigate();

  const user0 = require('assets/Profile/buku_default_avatar.png');
  const [expanded2, setExpanded2] = React.useState<boolean | undefined>(false);

  const handleExpand2Click = (): void => {
    setExpanded2(!expanded2);
  };

  const getPostId = () => {
    if (data.post) return data.post.id;
    else return data.nft ? data.nft.id : '';
  };

  return (
    <Card
      sx={{
        width: '100%',
        backgroundColor: 'transparent',
        boxShadow: 'unset',
        padding: '.5rem 0rem',
      }}
    >
      <TitleSectionContent>
        <UserSection>
          <img
            src={data.user?.avatar || user0}
            style={{
              width: '45px',
              height: '45px',
              borderRadius: '50%',
              objectFit: 'cover',
            }}
            alt={data.user.username}
          />
          <DetailSection>
            <NameSection>
              <NameText
                onClick={() => navigate(`/profile/${data.user?.username}/`)}
              >
                {data.user.username}
              </NameText>
              <NameText>
                {moment(data.createdDate).toNow(true) + ' ago'}
              </NameText>
            </NameSection>
            <CommitText>{data.content}</CommitText>
            <ExpandMore
              expand={expanded2}
              onClick={handleExpand2Click}
              aria-expanded={expanded2}
              aria-label="show more"
              sx={{ margin: 'unset', padding: 'unset' }}
            >
              <SmallText>Answers {`(${data.children?.length || 0})`}</SmallText>
            </ExpandMore>
          </DetailSection>
        </UserSection>
      </TitleSectionContent>

      <Collapse in={expanded2} timeout="auto" unmountOnExit>
        <Box>
          {data.children?.map((comment, i) => (
            <UserSection key={i} style={{ margin: '10px 0px' }}>
              <img
                src={comment.user?.avatar || user0}
                style={{
                  width: '32.5px',
                  height: '30px',
                  borderRadius: '50%',
                  objectFit: 'cover',
                  marginLeft: '20px',
                  marginTop: '10px',
                }}
                alt={comment.user.username}
              />
              <DetailSection>
                <NameSection>
                  <NameText
                    onClick={() => navigate(`/profile/${data.user?.username}/`)}
                  >
                    {comment.user.username}
                  </NameText>
                  <NameText>{comment.createdDate}</NameText>
                </NameSection>
                <CommitText>{comment.content}</CommitText>
              </DetailSection>
            </UserSection>
          ))}
        </Box>

        <InsideBottomContent
          style={{
            alignItems: 'center',
            width: 'calc(100% - 20px)',
            marginLeft: 'auto',
          }}
        >
          <OtrCommentInput
            ownerId={data.user.id || otr?.user.id}
            parentCommentId={`${data.id}` || ''}
            postId={`${getPostId()}` || ''}
            addComment={addComment}
            type={type}

          />
        </InsideBottomContent>
      </Collapse>
    </Card>
  );
};

export default CardCommentListsWithData;
